import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c046c668&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/global/Breadcrumbs/index.vue').default,Tag: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/global/Tag/index.vue').default})
